import OrderedList from "@tiptap/extension-ordered-list";

/**
 * Extends TipTap's OrderedList with a `listStyle` attribute to support
 * enumitem label variants (roman, Roman, alph, Alph).
 */

const listStyleToCSS: Record<string, string> = {
    "upper-roman": "upper-roman",
    "lower-roman": "lower-roman",
    "upper-alpha": "upper-alpha",
    "lower-alpha": "lower-alpha",
};

export const CustomOrderedList = OrderedList.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            listStyle: {
                default: null,
                parseHTML: (el) => el.getAttribute("data-list-style") || null,
                renderHTML: (attrs) => {
                    if (!attrs.listStyle) return {};
                    const cssType = listStyleToCSS[attrs.listStyle] ?? attrs.listStyle;
                    return {
                        "data-list-style": attrs.listStyle,
                        style: `list-style-type: ${cssType}`,
                    };
                },
            },
        };
    },
});
